import { render, staticRenderFns } from "./askVote.vue?vue&type=template&id=23032930&scoped=true&"
import script from "./askVote.vue?vue&type=script&lang=js&"
export * from "./askVote.vue?vue&type=script&lang=js&"
import style0 from "./askVote.vue?vue&type=style&index=0&id=23032930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23032930",
  null
  
)

export default component.exports